import { render, staticRenderFns } from "./uploadReceives.vue?vue&type=template&id=ecd0ab4a&scoped=true&"
import script from "./uploadReceives.vue?vue&type=script&lang=js&"
export * from "./uploadReceives.vue?vue&type=script&lang=js&"
import style0 from "./uploadReceives.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./uploadReceives.vue?vue&type=style&index=1&id=ecd0ab4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd0ab4a",
  null
  
)

export default component.exports